@if (!bannerRacingName) {
    <div class="sk-container" [ngClass]="{ 'sk-loading': !bannerRacingName }">
        <outlet-status [skeletonType]="'GENERIC_FULL'" [state]="state">
            @if (state.error) {
                <request-error [loadFailed]="state.error" (reloadFn)="reloadComponent()"></request-error>
            }
        </outlet-status>
    </div>
}
<ng-container>
    <div class="top-bar-block-space" [ngStyle]="{ 'z-index': topBarIndex }">
        @if (racingName) {
            <div [style.contain-intrinsic-size]="(minHeights?.header || 40) + 'px'" [style.min-height.px]="minHeights?.header || 40">
                <top-bar
                    [title]="'sb.' + racingName"
                    [iconId]="racingIconId"
                    data-crlat="topBar"
                    [iconSvg]="racingIconSvg"
                    [path]="racingDefaultPath"
                    [innerContent]="racingName === 'horseracing'"
                    (titleFunc)="goToDefaultPage()"
                    [isHorseRacingDetailPage]="isHRDetailPage"
                    [ngStyle]="{ 'z-index': topBarIndex }"
                    [isRouteRequestSuccess]="isRouteRequestSuccess">
                    @if (meetingsTitle) {
                        <breadcrumbs
                            [items]="breadcrumbsItems"
                            (navigationMenu)="showMeetingsList()"
                            [isExpanded]="showMeetings"
                            [menuItems]="quickNavigationItems"
                            [sportName]="racingName"
                            [defaultTab]="defaultTab">
                        </breadcrumbs>
                    }
                    @if (meetingsTitle) {
                        <quick-navigation
                            [items]="quickNavigationItems"
                            [showMenu]="showMeetings"
                            (showMeetingsListFn)="showMeetingsList()"
                            [meetingsTitle]="meetingsTitle"
                            [eventEntity]="eventEntity"
                            [races]="races"
                            [eventsOrder]="eventsOrder"
                            [sectionTitle]="sectionTitle"
                            [sportName]="racingName"
                            [filter]="filter"
                            [display]="display"
                            [sportEventsData]="sportEventsData"
                            [isExtraPlaceAvailable]="isExtraPlaceAvailable"
                            [nextRacesComponentEnabled]="nextRacesComponentEnabled"
                            [categoryId]="categoryId"
                            [sportModule]="sportModule"
                            [offersAndFeaturedRacesTitle]="offersAndFeaturedRacesTitle"
                            [isMarketAntepost]="isMarketAntepost">
                        </quick-navigation>
                    }
                    <top-bar-body class="top-bar-side" data-crlat="topBarContent">
                        <div class="bet-finder-link-with-my-stable" [ngClass]="{ 'bet-filter-my-stable-conatiner': userService?.status }">
                            @if (isBetFilterLinkAvailable) {
                                <a
                                    [routerLink]="'/bet-finder'"
                                    class="bet-finder-link"
                                    [ngClass]="{ 'bet-finder-link-after-my-stable': userService?.status }"
                                    data-crlat="betFinderLink">
                                    <div [ngClass]="{ 'bet-finder-wrapper coral-mobile-bet-finder-wrapper': userService?.status }">
                                        <svg class="bet-finder-icon" [ngClass]="{ 'coral-mobile-bet-finder-icon': userService?.status }">
                                            <use xlink:href="#bet-finder-icon"></use>
                                        </svg>
                                        <span
                                            class="bet-finder-title"
                                            data-crlat="betFinderTitle"
                                            [i18n]="'bf.betFinder'"
                                            [ngClass]="{ 'coral-mobile-bet-finder-title': userService?.status }"></span>
                                    </div>
                                </a>
                            }
                            @if (racingName == 'horseracing' && userService?.status) {
                                <lazy-component
                                    moduleUri="@lazy-modules-module/myStableRacingModule/mystable-racing.module#myStableRacingModule"
                                    entryComponent="MyStableEntrypointComponent"
                                    [inputs]="{ racingName: racingName, isHRDetailPage: isHRDetailPage, eventEntity: eventEntity }">
                                </lazy-component>
                            }
                        </div>
                    </top-bar-body>
                </top-bar>
            </div>
        }
    </div>
    @if (bannerRacingName && !isDetailPage) {
        <div [style.min-height.px]="isBannersEnabled && isBannersAvailable ? 177 : 0" style="overflow: hidden">
            <banners-section [page]="bannerRacingName" (bannersLoaded)="checkForBanners($event)"></banners-section>
        </div>
    }
</ng-container>

<div class="sk-container" [ngClass]="{ 'sk-loading': state.loading }">
    <outlet-status [skeletonType]="'GENERIC_FULL'" [state]="state">
        @if (state.error) {
            <request-error [loadFailed]="state.error" (reloadFn)="reloadComponent()"></request-error>
        }
    </outlet-status>
    @if (!state.loading && !state.error) {
        @if (!isDetailPage && isRouteRequestSuccess) {
            <div [style.min-height.px]="47">
                @if (isChildComponentLoaded) {
                    <switchers
                        class="tab-switchers"
                        [type]="'scrollable'"
                        [switchers]="racingTabs"
                        [activeTab]="activeTab"
                        [noPaddings]="true"
                        [detectGTMLocation]="'location'"
                        [preventReload]="true"></switchers>
                }
            </div>
            <!--- Navigation Points -->
            <div [ngStyle]="isSuperButtonAvailable ? { 'min-height': '75px', 'margin': '10px 0' } : { 'min-height': '0', 'margin': '0' }">
                @if (isChildComponentLoaded) {
                    <lazy-component
                        moduleUri="@lazy-modules-module/superButton/super-button.module#SuperButtonModule"
                        [inputs]="{
                            type: 'sport',
                            categoryId: categoryId,
                        }">
                    </lazy-component>
                }
            </div>
        }
        @if (isClsProcessed) {
            <router-outlet></router-outlet>
        }
        @if (srmQuickBetSelectionData) {
            <srm-loading-overlay></srm-loading-overlay>
            <srm-quickbet-panel-wrapper
                [selection]="srmQuickBetSelectionData.selection"
                [betslipType]="'quickbet_stakes'"
                [isSRMBet]="true"
                [selectedQuestionAndAnswers]="srmQuickBetSelectionData.selectedQuestionAndAnswers"
                [srmSelectedChannels]="srmQuickBetSelectionData.srmSelectedChannels"
                [srmOdds]="srmQuickBetSelectionData.srmOdds"
                [selectionEventLocalTime]="srmQuickBetSelectionData.selectionEventLocalTime">
            </srm-quickbet-panel-wrapper>
        }
    }
</div>
